import { createFileRoute } from '@tanstack/react-router';

import { LAST_VISITED_AGENT_ID_KEY } from '@/constants';
import { Inbox } from '@/features/agents';

export const Route = createFileRoute('/_auth/_org/agents/$agentId/inbox')({
  beforeLoad: async ({ params: { agentId } }) => {
    localStorage.setItem(LAST_VISITED_AGENT_ID_KEY, agentId);
  },
  component: Inbox,
});
